export default {
  name: 'appendToBodyPlugin',

  // 插件是否自动安装
  autoInstall: true,

  install (Vue, options) {
    if (
      Vue &&
      Vue.options &&
      Vue.options.components &&
      Vue.options.components.ElDialog
    ) {
      // 修改内置的ElDialog默认值
      const ElDialog = Vue.options.components.ElDialog;
      ElDialog.options.props.appendToBody.default = true;
    }

    if (
      Vue &&
      Vue.options &&
      Vue.options.components &&
      Vue.options.components.ElDrawer
    ) {
      // 修改内置的ElDrawer默认值
      const ElDrawer = Vue.options.components.ElDrawer;
      ElDrawer.options.props.appendToBody.default = true;
    }
  }
};



// WEBPACK FOOTER //
// ./~/vue-xpc/src/plugins/appendToBody/index.js